import { FiatTransactionDetails } from 'BreetComponents';
import { FXRATE } from 'BreetHelpers';
import { useCurrencyConverterContext } from 'BreetHooks';

const SendFiatTransactionDetails = () => {
	const { formDataContextProps } = useCurrencyConverterContext();

	const fromCurrencyCode = formDataContextProps.hookFormProps.watch('fromCurrency');
	const toCurrencyCode = formDataContextProps.hookFormProps.watch('toCurrency');
	const amount = formDataContextProps.hookFormProps.watch('amount');

	return (
		<FiatTransactionDetails
			amount={amount}
			fxRate={FXRATE.DEFAULT}
			fromCurrencyCode={fromCurrencyCode}
			toCurrencyCode={toCurrencyCode}
		/>
	);
};

export default SendFiatTransactionDetails;
